/**
 * If something goes really wrong, we show the fallback wallpaper,
 * and try to show another wallpaper in ten seconds
 */

function isTransferBlocked({ transfer, route }) {
  return transfer.state === 'blocked' && route.path.startsWith('/downloads/');
}

export const FallbackProvider = {
  get name() {
    return 'FALLBACK_PROVIDER';
  },

  isRotationEnabled() {
    return true;
  },

  rotationInterval(config) {
    return config.fallback.rotationInterval;
  },

  test(config, state) {
    return state.wallpaper.error === true || isTransferBlocked(state);
  },

  nextCreative(config) {
    return {
      src: `${config.host}${config.fallback.src}`,
      format: config.format.HTML5,
    };
  },
};
